import productHighlightsStories from "./ProductHighlights/stories";

const stories = {
  name: "sales-dashboard",
  children: [productHighlightsStories],
};

export default stories;
